import {
  CaracteristicasState,
  MetadataState,
  caracteristicasInitialState,
  metadataInitialState,
  CaracteristicasAction,
} from 'store/modules/notaComercial/caracteristicas';
import {
  CriteriosRemuneracaoAction,
  criteriosRemuneracaoInitialState,
} from 'store/modules/notaComercial/criteriosRemuneracao';
import {
  EventosAction,
  eventosInitialState,
} from 'store/modules/notaComercial/eventos';
import { UploadDocumentosAction, uploadDocumentosInitialState } from 'store/modules/notaComercial/uploadDocumentos';
import {
  EmissorAction,
  State as EmissorState,
  initialState as emissorInitialState,
} from 'store/modules/notaComercial/emissor';
import { CriteriosRemuneracao, UploadDocumentos, AmortizacaoDataGrid, TipoRegistroInstrumentoFinanceiro, EventosFinanceiros as EventosState } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Attachment } from 'components/uploadDocs';
import { AditamentoAction } from './aditamento';

interface IStateNotaComercial {
  caracteristicas: CaracteristicasState;
  metadata: MetadataState;
  criteriosRemuneracao: CriteriosRemuneracao;
  emissor: EmissorState;
  eventos: EventosState;
  uploadDocumentos: UploadDocumentos;
  highlightErrors: boolean;
  typeOfRegister: TipoRegistroInstrumentoFinanceiro;
  uploadDocumentoAditamento: Attachment[];
  dataAditamento: string | undefined;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('notaComercial/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('notaComercial/HIGHLIGHT_ERRORS', payload);
};

export function notaComercialReducer(
  state: IStateNotaComercial = {
    caracteristicas: caracteristicasInitialState,
    metadata: metadataInitialState,
    criteriosRemuneracao: criteriosRemuneracaoInitialState,
    emissor: emissorInitialState,
    eventos: eventosInitialState,
    uploadDocumentos: uploadDocumentosInitialState,
    highlightErrors: false,
    typeOfRegister: TipoRegistroInstrumentoFinanceiro.Cadastro,
    uploadDocumentoAditamento: [],
    dataAditamento: undefined,
  },
  action:
    | CaracteristicasAction
    | CriteriosRemuneracaoAction
    | EmissorAction
    | EventosAction
    | UploadDocumentosAction
    | ReturnType<typeof highlightErrors>
    | ReturnType<typeof typeOfRegister>
    | AditamentoAction
): IStateNotaComercial {
  switch (action.type) {
    //Características
    case 'notaComercial/metadata/UPDATEFIELD':
      return { ...state, metadata: { ...state.metadata, [action.payload.name]: action.payload.value } };
    case 'notaComercial/metadata/RESET':
      return { ...state, metadata: { ...metadataInitialState } };
    case 'notaComercial/caracteristicas/UPDATEFIELD':
      return { ...state, caracteristicas: { ...state.caracteristicas, [action.payload.name]: action.payload.value } };
    case 'notaComercial/caracteristicas/RESET':
      return { ...state, caracteristicas: { ...caracteristicasInitialState } };
    case 'notaComercial/caracteristicas/UPDATE':
      return { ...state, caracteristicas: action.payload };
    //Critério de Remuneração
    case 'notaComercial/criteriosRemuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: { ...state.criteriosRemuneracao, [action.payload.name]: action.payload.value },
      };
    case 'notaComercial/criteriosRemuneracao/remuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: { ...state.criteriosRemuneracao.remuneracao, [action.payload.name]: action.payload.value },
        },
      };
    case 'notaComercial/criteriosRemuneracao/remuneracao/UPDATE':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: action.payload,
        },
      };
    case 'notaComercial/criteriosRemuneracao/RESET':
      return { ...state, criteriosRemuneracao: criteriosRemuneracaoInitialState };
    case 'notaComercial/criteriosRemuneracao/UPDATE':
      return { ...state, criteriosRemuneracao: action.payload };
    //Custo de Emissão
    case 'notaComercial/criteriosRemuneracao/custoEmissao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          custoEmissao: {
            ...state.criteriosRemuneracao.custoEmissao, [action.payload.name]: action.payload.value
          },
        }
      };
    //Emissor
    case 'notaComercial/emissor/UPDATE_ID':
      return { ...state, emissor: { ...state.emissor, id: action.payload } };
    case 'notaComercial/emissor/UPDATE_CODIGO':
      return { ...state, emissor: { ...state.emissor, codigoExterno: action.payload } };
    case 'notaComercial/emissor/UPDATE_CODIGO_INSTRUMENTO':
      return { ...state, emissor: { ...state.emissor, codigoInstrumento: action.payload } };
    case 'notaComercial/emissor/RESET':
      return { ...state, emissor: { ...emissorInitialState } };
    //Eventos Financeiros
    case 'notaComercial/eventos/UPDATE':
      return { ...state, eventos: action.payload };
    case 'notaComercial/eventos/UPDATEFIELD':
      return { ...state, eventos: { ...state.eventos, [action.payload.name]: action.payload.value } };
    case 'notaComercial/eventos/RESET':
      return { ...state, eventos: eventosInitialState };
    case 'notaComercial/eventos/datasPagamentoJuros/UPDATE':
      return {
        ...state,
        eventos: { ...state.eventos, datasPagamentoJuros: action.payload.map((dateViewModel) => dateViewModel.date) },
      };
    case 'notaComercial/eventos/datasIncorporacaoJuros/UPDATE':
      return {
        ...state,
        eventos: {
          ...state.eventos,
          datasIncorporacaoJuros: action.payload.map((dateViewModel) => dateViewModel.date),
        },
      };
    case 'notaComercial/eventos/amortizacoes/UPDATE':
      const amortizacoes: AmortizacaoDataGrid[] = action.payload.map((amortizacao) => ({
        percentualAmortizacao: amortizacao.percentualAmortizacao,
        dataAmortizacao: amortizacao.dataAmortizacao,
        isNew: true,
        id: '',
      }));
      return {
        ...state,
        eventos: { ...state.eventos, amortizacoes },
      };
    //Documentos
    case 'notaComercial/uploadDocumentos/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documents: action.payload },
      };
    case 'notaComercial/uploadDocumentos/documentsToDelete/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documentsToDelete: action.payload },
      };
    case 'notaComercial/uploadDocumentos/RESET':
      return { ...state, uploadDocumentos: uploadDocumentosInitialState };
    //Erros
    case 'notaComercial/HIGHLIGHT_ERRORS':
      return { ...state, highlightErrors: action.payload };
    //Type of Register
    case 'notaComercial/TYPE_OF_REGISTER':
      return { ...state, typeOfRegister: action.payload };
    //Aditamento
    case 'notaComercial/UPLOAD_DOCUMENTO_ADITAMENTO':
      return { ...state, uploadDocumentoAditamento: action.payload };
    case 'notaComercial/UPLOAD_DOCUMENTO_ADITAMENTO/RESET':
      return { ...state, uploadDocumentoAditamento: [] };
    case 'notaComercial/DATA_ADITAMENTO':
      return { ...state, dataAditamento: action.payload };
    case 'notaComercial/DATA_ADITAMENTO/RESET':
      return { ...state, dataAditamento: undefined };
    default:
      return state;
  }
}

export default notaComercialReducer;
